import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Typography,
  styled,
  TextField,
  Paper,
  Grid,
  Box,
  Fab,
  MenuItem,
  Snackbar,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Checkbox,
  Radio
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { doc, getDoc } from "firebase/firestore";
import { serverTimestamp } from "firebase/firestore";
import { SaveCloseDialog } from "../components/SaveCloseDialog";
import { Save, Close } from "@mui/icons-material";
import ClearIcon from '@mui/icons-material/Clear';
import { Context } from "context/Wrapper";
import { useFetchCollectionDocs } from "apis/dataSnapshots";
import { or, where } from "firebase/firestore";
import { db } from "config/config";
import InfiniteScrollSelect from "components/shared/InfiniteScrollSelect";
import { CreateUniqueDocument } from "components/shared/createUniqueDocument ";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Item = styled(Paper)(({ theme }) => {
  return {
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.primary.main,
    background: theme.palette.secondary.main,
  };
});

export const BuildingNew = (props) => {
  const navigate = useNavigate();

  const context = useContext(Context);

  const { groupId, isPro, userId } = context?.state?.userProfile || {};
  const user = context?.state?.userProfile || {},
    { showAllDataFlag } = context?.state || {};

  const contacts = useFetchCollectionDocs({
    collectionName: "contacts",
    conditions:
      userId && groupId && isPro && showAllDataFlag
        ? [or(where("groupId", "==", groupId), where("userId", "==", userId))]
        : userId
          ? [where("userId", "==", userId)]
          : [],
  });

  const [buildingDetail, setBuildingDetail] = useState({});

  const [open, setOpen] = React.useState(false);

  const [failureOpen, setOpenFailure] = React.useState(false);
  const [duplicateOpen, setduplicateOpen] = React.useState(false);
  const [SubmitLoader, setSubmitLoader] = React.useState(false);

  const [dialogOpen, setDialogOpen] = React.useState(false);

  const [isDirty, setIsDirty] = React.useState(false);

  const [addedSuccessfullyOpen, setAddedSuccessfullyOpen] = React.useState(false)



  const openAddedSuccessfully = () => {
    setAddedSuccessfullyOpen(true);
  };

  const handleCloseAddedSuccessfully = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAddedSuccessfullyOpen(false);
  };



  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleFailureClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenFailure(false);
  };

  const handleduplicateOpen = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setduplicateOpen(false);
  };


  const handleChange = (e) => {
    let currentBuildingDetail = { ...buildingDetail };

    if (e.target.type === "checkbox") {
      currentBuildingDetail[e.target.name] = e.target.checked;
    } else {
      currentBuildingDetail[e.target.name] = e.target.value;
    }

    setIsDirty(true);
    setBuildingDetail({ ...currentBuildingDetail });
  };

const onSubmit = async (data) => {
  const fullAddress = [
    `${buildingDetail.houseNumber || ""} ${buildingDetail.streetName || ""}`,
    buildingDetail.city,
    buildingDetail.state,
    buildingDetail.ZIP,
  ]
    .filter(Boolean)
    .join(", ");

  // lookup ownerString
  let ownerString = "";
  if (buildingDetail.owner) {
    const snap = await getDoc(doc(db, "contacts", buildingDetail.owner));
    ownerString = snap.exists() ? snap.data().businessName || "" : "";
  }

  // Get current timestamp in epoch format
  const currentTimestamp = Date.now();

  CreateUniqueDocument({
    openAddedSuccessfully,
    navigate: navigate,
    db: db,
    collectionName: "buildings",
    data: {
      ...buildingDetail,
      dateCreated: currentTimestamp, // Changed from serverTimestamp() to epoch
      dateUpdated: currentTimestamp, // Changed from serverTimestamp() to epoch
      fullAddress_lc: fullAddress.toLowerCase(),
      customerReference_lc: buildingDetail.customerReference.trim().toLowerCase(),
      borough_lc: (buildingDetail.borough || '').trim().toLowerCase(),
      ownerString_lc: ownerString.toLowerCase(),
      userId: user.uid,
      groupId: groupId
    },
    uniqueFieldName: "customerReference",
    failureCallback: () => {
      console.error("Error adding document.");
      setSubmitLoader(false)
    },
    duplicateCallback: () => {
      setduplicateOpen(true);
      setSubmitLoader(false)
    },
    loadingCallback: () => {
      setSubmitLoader(true)
    }
  });
};

  const saveAndClose = () => {
    onSubmit(buildingDetail);
  };

  const discardAndClose = () => {
    navigate("/buildings");
  };

  const handleCloseBuilding = () => {
    if (isDirty) {
      setDialogOpen(true);
      return;
    }
    navigate("/buildings");
  };

  const hasRequiredFields = () => {
    return (
      buildingDetail.customerReference &&
      buildingDetail.houseNumber &&
      buildingDetail.streetName
    );
  };

  return (
    <>
      <Typography
        sx={{ textTransform: "uppercase", marginBottom: "1rem" }}
        align="left"
        variant="h4"
      >
        New Building
      </Typography>

      <Grid container spacing={2}>

        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Name"
            variant="outlined"
            name="customerReference"
            value={buildingDetail.customerReference}
            onChange={handleChange}
            fullWidth
            required
          />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label={"Borough"}
            name="borough"
            select
            onChange={handleChange}
            value={buildingDetail.borough || ""}
            fullWidth
            InputProps={{
              endAdornment: buildingDetail.borough ? (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => handleChange({ target: { name: 'borough', value: '' } })}
                    style={{ marginRight: '10px' }}
                  >
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              ) : null
            }}
          >
            <MenuItem value={"Brooklyn"}>Brooklyn</MenuItem>
            <MenuItem value={"Manhattan"}>Manhattan</MenuItem>
            <MenuItem value={"Bronx"}>Bronx</MenuItem>
            <MenuItem value={"Queens"}>Queens</MenuItem>
            <MenuItem value={"Staten Island"}>Staten Island</MenuItem>
          </TextField>
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <InfiniteScrollSelect
            collectionName="contacts"
            label="fullName"
            onChange={handleChange}
            value={buildingDetail.owner}
            name="owner"
            inputLabel="Owner"
          />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="BIN"
            variant="outlined"
            name="BIN"
            value={buildingDetail.BIN}
            onChange={handleChange}
            fullWidth
          />
        </Grid>

      </Grid>



      <Typography align="left" variant="h4" sx={{ fontWeight: "bold", color: "#111715", marginTop: "30px", marginBottom: "20px" }}>
        Address Details
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="House number"
            variant="outlined"
            name="houseNumber"
            value={buildingDetail.houseNumber}
            onChange={handleChange}
            fullWidth

          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Street name"
            variant="outlined"
            name="streetName"
            value={buildingDetail.streetName}
            onChange={handleChange}
            fullWidth

          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Special place name"
            variant="outlined"
            name="specialPlaceName"
            value={buildingDetail.specialPlaceName}
            onChange={handleChange}
            fullWidth

          />
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="City"
            variant="outlined"
            name="city"
            value={buildingDetail.city}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="State"
            variant="outlined"
            name="state"
            value={buildingDetail.state}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="ZIP"
            variant="outlined"
            name="ZIP"
            value={buildingDetail.ZIP}
            onChange={handleChange}
            fullWidth
          />
        </Grid>

      </Grid>


      <Typography align="left" variant="h4" sx={{ fontWeight: "bold", color: "#111715", marginTop: "30px", marginBottom: "20px" }}>
        More Address Details
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Block"
            variant="outlined"
            name="block"
            value={buildingDetail.block}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Lot"
            variant="outlined"
            name="lot"
            value={buildingDetail.lot}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="CB No."
            variant="outlined"
            name="cb"
            value={buildingDetail.cb}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Zoning District"
            variant="outlined"
            name="zoningDistrict"
            value={buildingDetail.zoningDistrict}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Special District"
            variant="outlined"
            name="specialDistrict"
            value={buildingDetail.specialDistrict}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Map Number"
            variant="outlined"
            name="mapNumber"
            value={buildingDetail.mapNumber}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Overlays"
            variant="outlined"
            name="overlays"
            value={buildingDetail.overlays}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
      </Grid>


      <Typography align="left" variant="h4" sx={{ fontWeight: "bold", color: "#111715", marginTop: "30px", marginBottom: "20px" }}>
        Building Characteristics
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Height"
            variant="outlined"
            name="heightExisting"
            value={buildingDetail.heightExisting}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Stories"
            variant="outlined"
            name="storiesExisting"
            value={buildingDetail.storiesExisting}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Units"
            variant="outlined"
            name="unitsExisting"
            value={buildingDetail.unitsExisting}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Street Frontage"
            variant="outlined"
            name="streetFrontage"
            value={buildingDetail.streetFrontage}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Floor Area"
            variant="outlined"
            name="totalFloorArea"
            value={buildingDetail.totalFloorArea}
            onChange={handleChange}
            fullWidth
          />
        </Grid>


      </Grid>


      <Grid container spacing={2} marginTop={"11px"}>
        {[
          { label: "Landmark", name: "landmark" },
          { label: "Hazmat Site", name: "hazmatSite" },
          { label: "Adult Establishment", name: "adultEstablishment" },
          { label: "SRO", name: "sro" },
          { label: "Street Private", name: "streetPrivate" },
          { label: "Public", name: "public" },
          { label: "123 Family", name: "oneTwoThreeFamily" },
          { label: "Mixed Use", name: "mixedUse" },
          { label: "Other Type", name: "otherType" },
          { label: "Tidal Wetland", name: "tidalWetland" },
          { label: "Urban Renewable", name: "urbanRenewable" },
          { label: "Fire District", name: "fireDistrict" },
          { label: "Flood Hazard", name: "floodHazard" },
          { label: "Unmapped Street", name: "unmappedStreet" }
        ].map((it) => (
          <Grid item xs={12} md={6} lg={4} key={it.name}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={buildingDetail[it.name] || false}
                  onChange={handleChange}
                  name={it.name}
                  sx={{ padding: 0 }}
                />
              }
              label={it.label}
              sx={{
                margin: 0,
                fontSize: "0.875rem",
                display: "flex",
                alignItems: "center",
              }}
            />
          </Grid>
        ))}


      </Grid>


      <Grid container spacing={2} marginTop={"11px"}>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Structural Occupancy Category"
            variant="outlined"
            name="structuralOccupancyCategory"
            value={buildingDetail.structuralOccupancyCategory}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            select
            label="Construction Classification"
            variant="outlined"
            name="constructionClassification"
            value={buildingDetail.constructionClassification || ""}
            onChange={handleChange}
            fullWidth
            InputProps={{
              endAdornment: buildingDetail.constructionClassification ? (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => handleChange({ target: { name: 'constructionClassification', value: '' } })}
                    style={{ marginRight: '10px' }}
                  >
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              ) : null
            }}
          >
            {[
              "1", "1-A", "1-B", "1-C", "1-D", "1-E",
              "2", "2-A", "2-B", "2-C", "2-D", "2-E",
              "3", "3-A", "3-B", "4", "4-HT", "5", "5-A", "5-B", "6"
            ].map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Grid>


        <Grid item xs={12} md={6} lg={4}>
          <TextField
            select
            label="Occupancy Classification"
            variant="outlined"
            name="occupancyClassification"
            value={buildingDetail.occupancyClassification || ""}
            onChange={handleChange}
            fullWidth
            InputProps={{
              endAdornment: buildingDetail.occupancyClassification ? (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => handleChange({ target: { name: 'occupancyClassification', value: '' } })}
                    style={{ marginRight: '10px' }}
                  >
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              ) : null
            }}
          >
            {[
              "A", "A-1", "A-2", "A-3", "A-4", "A-5",
              "B", "B-1", "B-2", "C", "COM", "D-1", "D-2",
              "E", "F-1", "F-1A", "F-1B", "F-2", "F-3", "F-4",
              "G", "H-1", "H-2", "H-3", "H-4", "H-5", "I-1", "I-2", "I-3", "I-4",
              "J-1", "J-2", "J-3", "K", "M", "PUB", "R-1", "R-2", "R-3", "RES",
              "S-1", "S-2", "U"
            ].map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Multiple Dwelling Class"
            variant="outlined"
            name="multipleDwellingClass"
            value={buildingDetail.multipleDwellingClass}
            onChange={handleChange}
            fullWidth
          />
        </Grid>

      </Grid>


      <Typography align="left" variant="h4" sx={{ fontWeight: "bold", color: "#111715", marginTop: "30px", marginBottom: "20px" }}>
        Fire Protection Equipment
      </Typography>
      <Grid container spacing={2}>
        {[
          { label: "Fire Alarm", name: "fireAlarm" },
          { label: "Sprinkler", name: "sprinkler" },
          { label: "Fire Suppression", name: "fireSuppression" },
          { label: "Stand Pipe", name: "standPipe" },
        ].map((it) => (
          <Grid item xs={12} md={6} lg={4} key={it.name}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={buildingDetail[it.name] || false}
                  onChange={handleChange}
                  name={it.name}
                  sx={{ padding: 0 }}
                />
              }
              label={it.label}
              sx={{
                margin: 0,
                fontSize: "0.875rem",
                display: "flex",
                alignItems: "center",
              }}
            />
          </Grid>
        ))}

      </Grid>


      <Typography align="left" variant="h4" sx={{ fontWeight: "bold", color: "#111715", marginTop: "30px", marginBottom: "20px" }}>
        Primary Structural System
      </Typography>
      <Grid container spacing={2}>
        {[
          { label: "Masonry", name: "masonry" },
          { label: "Concrete (CIP)", name: "concreteCIP" },
          { label: "Concrete (Precast)", name: "concretePrecast" },
          { label: "Wood", name: "wood" },
          { label: "Steel (Structural)", name: "steelStructural" },
          { label: "Steel (Cold-Formed)", name: "steelColdFormed" },
          { label: "Steel (Encased in Concrete)", name: "steelEncasedInConcrete" },
        ].map((it) => (
          <Grid item xs={12} md={6} lg={4} key={it.name}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={buildingDetail[it.name] || false}
                  onChange={handleChange}
                  name={it.name}
                  sx={{ padding: 0 }}
                />
              }
              label={it.label}
              sx={{
                margin: 0,
                fontSize: "0.875rem",
                display: "flex",
                alignItems: "center",
              }}
            />
          </Grid>
        ))}

      </Grid>





      <Typography align="left" variant="h4" sx={{ fontWeight: "bold", color: "#111715", marginTop: "30px", marginBottom: "20px" }}>
        Open Spaces
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Plaza"
            variant="outlined"
            name="plaza"
            value={buildingDetail.plaza}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Parking Area"
            variant="outlined"
            name="parkingArea"
            value={buildingDetail.parkingArea}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Arcade"
            variant="outlined"
            name="arcade"
            value={buildingDetail.arcade}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Parking Spaces"
            variant="outlined"
            name="parkingSpaces"
            value={buildingDetail.parkingSpaces}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Loading Area"
            variant="outlined"
            name="loadingArea"
            value={buildingDetail.loadingArea}
            onChange={handleChange}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <TextField
            label="Loading Berths"
            variant="outlined"
            name="loadingBerths"
            value={buildingDetail.loadingBerths}
            onChange={handleChange}
            fullWidth
          />
        </Grid>

      </Grid>





      <Typography align="left" variant="h4" sx={{ fontWeight: "bold", color: "#111715", marginTop: "30px", marginBottom: "20px" }}>
        Code Requirements
      </Typography>

      <Grid container spacing={2} alignItems="center">

        <Grid item xs={12} md={6} lg={4}>
          <Typography variant="h6" sx={{}}>
            Building was originally erected pursuant to which Building Code:
          </Typography>
        </Grid>

        <Grid item xs={12} md={6} lg={8}>
          <Grid container spacing={2}>
            {[
              { label: "2008", name: "2008" },
              { label: "1968", name: "1968" },
              { label: "Prior to 1968", name: "priorTo1968" },
            ].map((it) => (
              <Grid item xs={12} sm={6} md={4} key={it.name}>
                <FormControlLabel
                  control={
                    <Radio
                      checked={buildingDetail.pursuantBuildingCode === it.name}
                      onChange={handleChange}
                      value={it.name}
                      name="pursuantBuildingCode"
                      sx={{ padding: 0 }}
                    />
                  }
                  label={it.label}
                  sx={{
                    margin: 0,
                    fontSize: "0.875rem",
                    display: "flex",
                    alignItems: "center",
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>






        <Grid item xs={12} md={6} lg={4}>
          <Typography variant="h6" sx={{}}>
            The earliest code with which this building or any part of it is required:
          </Typography>
        </Grid>

        <Grid item xs={12} md={6} lg={8}>
          <Grid container spacing={2}>
            {[
              { label: "2008", name: "2008" },
              { label: "1968", name: "1968" },
              { label: "Prior to 1968", name: "priorTo1968" },
            ].map((it) => (
              <Grid item xs={12} sm={6} md={4} key={it.name}>
                <FormControlLabel
                  control={
                    <Radio
                      checked={buildingDetail.earlyCodeRequired === it.name}
                      onChange={handleChange}
                      value={it.name}
                      name="earlyCodeRequired"
                      sx={{ padding: 0 }}
                    />
                  }
                  label={it.label}
                  sx={{
                    margin: 0,
                    fontSize: "0.875rem",
                    display: "flex",
                    alignItems: "center",
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>








      </Grid>














      <SaveCloseDialog
        open={dialogOpen}
        saveAndClose={saveAndClose}
        discardAndClose={discardAndClose}
        setDialogOpen={setDialogOpen}
      />

      <Box
        sx={{
          position: "fixed",
          bottom: "1rem",
          right: "1rem",
          "& > :not(style)": { m: 1 },
        }}
      >
        {!props.isInactive && (
          <Fab
            color="primary"
            aria-label="add"
            variant="extended"
            onClick={saveAndClose}
            form="buildingForm"
            disabled={SubmitLoader || (!isDirty && !hasRequiredFields()) || props.isInactive}
          >
            <Save sx={{ mr: 1 }} />
            {/* Save */}
            Add
          </Fab>
        )}
        <Fab
          color="secondary"
          aria-label="add"
          variant="extended"
          onClick={handleCloseBuilding}
        >
          <Close sx={{ mr: 1 }} />
          Cancel
        </Fab>
      </Box>
      <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          Building successfully saved!
        </Alert>
      </Snackbar>
      <Snackbar
        open={failureOpen}
        autoHideDuration={2000}
        onClose={handleFailureClose}
      >
        <Alert
          onClose={handleFailureClose}
          severity="error"
          sx={{ width: "100%" }}
        >
          Something went wrong!
        </Alert>
      </Snackbar>

      <Snackbar
        open={duplicateOpen}
        autoHideDuration={2000}
        onClose={handleduplicateOpen}
      >
        <Alert
          onClose={handleduplicateOpen}
          severity="error"
          sx={{ width: "100%" }}
        >
          Building name already exists!
        </Alert>
      </Snackbar>

      <Snackbar
        open={addedSuccessfullyOpen}
        autoHideDuration={2000}
        onClose={handleCloseAddedSuccessfully}
      >
        <Alert
          onClose={handleCloseAddedSuccessfully}
          severity="success"
          sx={{ width: "100%" }}
        >
          Building added successfully!
        </Alert>
      </Snackbar>

    </>
  );
};
